module.exports = __webpack_public_path__ + "static/media/video.338de740.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BushfireFront/video.jpg
// module id = 193
// module chunks = 0